export default "__VITE_ASSET__BfsYuYCA__"